import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Drawer, Toolbar, Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import Topbar from '../Topbar';
import BuildInfo from '../BuildInfo';
import Sidebar2 from './Sidebar2';
import { Context2, Selected2 } from './Context2';
import { I18nProvider } from '../i18n/I18nContext';

/**
 * Shell for /live2. A copy of Layout rather than a variant of it, because the two
 * boards share nothing at the data layer: Layout seeds its selection with a query
 * against `lines`, which does not exist in the new schema.
 *
 * No seeding query here at all — Sidebar2 already holds every visible journey, so
 * it selects the first one itself and saves a round trip.
 */

const theme = createTheme();
const drawerWidth = 240;

const Layout2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selected, setSelected] = useState<Selected2 | null>(null);
  const openSidebar = useMediaQuery(theme.breakpoints.up('lg'));
  const [forceOpen, setForceOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <I18nProvider>
      <Context2.Provider value={{ selected, setSelected }}>
        <CssBaseline />
        <Topbar menuState={forceOpen} openAction={setForceOpen} />

        <Box sx={{ display: 'flex' }}>
          <Drawer
            variant="temporary"
            open={openSidebar || forceOpen}
            hideBackdrop={true}
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', bgcolor: '#18364a' },
            }}
            onClick={() => setForceOpen(false)}
          >
            <Sidebar2 />
          </Drawer>

          <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3, mt: 8 }}>
            <Toolbar />
            {children}
          </Box>
        </Box>
        <BuildInfo />
      </Context2.Provider>
      </I18nProvider>
    </ThemeProvider>
  );
};

export default Layout2;
